import React from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

export default function SelectTemplateHeader() {
  const userSetter = useSelector(state => state.userSetter);
  const history = useHistory();
  return (
    <div className="page_heading">
      <h2>Select a Template</h2>
      <button
        className="btn btn-sm"
        style={{ color: "#114169" }}
        onClick={() => {
          userSetter.userFlow === "createCampaign" &&
            history.push(`/admin/campaign/create`);
          userSetter.userFlow === "createTemplate" &&
            history.push(`/admin/templates/info`);
        }}
      >{`< Back`}</button>
    </div>
  )
}
